{
  "REGISTER": {
    "TRY_WOOT": "Izveidot kontu",
    "TITLE": "Reģistrēt",
    "TESTIMONIAL_HEADER": "Viss, kas nepieciešams, ir viens solis, lai virzītos uz priekšu",
    "TESTIMONIAL_CONTENT": "Jūs esat viena soļa attālumā no klientu piesaistīšanas, noturēšanas un jaunu klientu atrašanas.",
    "TERMS_ACCEPT": "Izveidojot kontu, Jūs piekrītat mūsu <a href=\"https://chat.jarabot.com/terms\">T & C</a> and <a href=\"https://chat.jarabot.com/privacy-policy\">Privātuma politikai</a>",
    "TERMS_LINKS": "<a href=\"https://chat.jarabot.com/terms\">Noteikumi un nosacījumi</a> - <a href=\"https://chat.jarabot.com/privacy-policy\">Privātuma politika</a>",
    "OAUTH": {
      "GOOGLE_SIGNUP": "Reģistrēties, izmantojot Google"
    },
    "COMPANY_NAME": {
      "LABEL": "Uzņēmuma nosaukums",
      "PLACEHOLDER": "Ievadiet sava uzņēmuma nosaukumu. Piemēram, Wayne Enterprises",
      "ERROR": "Uzņēmuma nosaukums ir pārāk īss."
    },
    "FULL_NAME": {
      "LABEL": "Pilnais vārds",
      "PLACEHOLDER": "Ievadiet savu pilno vārdu. Piemēram, Brūss Veins",
      "ERROR": "Pilnais vārds ir pārāk īss."
    },
    "EMAIL": {
      "LABEL": "Darba e-pasts",
      "PLACEHOLDER": "Ievadiet savu darba e-pasta adresi. Piemēram, bruce{'@'}wayne{'.'}enterprises",
      "ERROR": "Lūdzu, ievadiet derīgu darba e-pasta adresi."
    },
    "PASSWORD": {
      "LABEL": "Parole",
      "PLACEHOLDER": "Parole",
      "ERROR": "Parole ir pārāk īsa",
      "IS_INVALID_PASSWORD": "Parolei ir jāsatur vismaz 1 lielais burts, 1 mazais burts, 1 cipars un 1 speciālā rakstzīme."
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Apstipriniet paroli",
      "PLACEHOLDER": "Apstipriniet paroli",
      "ERROR": "Parole nesakrīt."
    },
    "API": {
      "SUCCESS_MESSAGE": "Reģistrācija sekmīga",
      "ERROR_MESSAGE": "Nevarēja izveidot savienojumu ar Woot serveri. Lūdzu mēģiniet vēlreiz."
    },
    "SUBMIT": "Izveidot kontu",
    "HAVE_AN_ACCOUNT": "Jau ir konts?"
  }
}
